export default __webpack_public_path__ + "static/profile-20352b9a383088c46ec30a844ebf74ad.jpg";